import { render, staticRenderFns } from "./WithdrawGameCreditModal.vue?vue&type=template&id=04affffd&"
import script from "./WithdrawGameCreditModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawGameCreditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports